import { getPortalSdk } from 'portal-sdk';
import { UseQueryOptions, useQuery } from 'react-query';

export type PortalConnections = NonNullable<
  Awaited<
    ReturnType<NonNullable<ReturnType<typeof getPortalSdk>>['listConnections']>
  >
>;

/** gets an array of Portal Connection's via react-query */
export const usePortalConnections = (
  options?: UseQueryOptions<PortalConnections>
) =>
  useQuery<PortalConnections>(
    'usePortalConnections',
    async () => {
      const sdk = getPortalSdk();
      if (!sdk) {
        throw new Error('!sdk');
      }

      const listConnections = await sdk.listConnections();
      if (!listConnections) {
        throw new Error('!listConnections');
      }

      return listConnections;
    },
    options
  );
